import {
  NPVR_FETCH_EVENT_LIST_INIT,
  NPVR_FETCH_EVENT_LIST_SUCCESS,
  NPVR_FETCH_EVENT_LIST_ERROR,
} from '../../actions/recording/constants';

const initialState = {
  loading: false,
  data: null,
  error: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case NPVR_FETCH_EVENT_LIST_INIT:
      return { ...state, loading: true, error: false };
    case NPVR_FETCH_EVENT_LIST_SUCCESS:
      return { ...state, data: action.payload, loading: false, error: false };
    case NPVR_FETCH_EVENT_LIST_ERROR:
      return { ...state, data: null, error: action.error };
    default:
      return state;
  }
};
